import type { ProspectActivity } from "../types";
import { ActivityCreate } from "./ActivityCreate";
import { ActivityEdit } from "./ActivityEdit";
import { ActivityList } from "./ActivityList";

export default {
  list: ActivityList,
  create: ActivityCreate,
  edit: ActivityEdit,
  recordRepresentation: (record: ProspectActivity) =>
    record?.title ?? record?.type ?? "",
};
